<template>
  <div class="vh-100 vw-100 d-flex">
    <div class="card shadow-sm border-0 debug-window" v-if="showDebug">
      <div class="card-body" v-if="false">
        baseline: {{ baseline.name }}<br>
        visible: {{ visible ? 'Yes' : 'No' }}<br>
        hipAngle: <span :class="{'text-success': checkAngle('hip')}">{{ hipAngle }}°</span><br>
        kneeAngle: <span :class="{'text-success': checkAngle('knee')}">{{ kneeAngle }}°</span><br>
        total: {{ total }}<br>
        validRepCount: {{ validRepCount }}<br>
        invalidRepsCount: {{ invalidRepsCount }}<br>
        totalRepDeviation: {{ totalRepDeviation }}°<br>
      </div>
      <div class="card-body">
        <span v-if="baseline">Baseline: {{ baseline.name }}<br></span>
        User Visible: {{ visible ? 'Yes' : 'No' }}<br>
        Hip Angle: <span :class="{'text-success': checkAngle('hip')}">{{ hipAngle }}°</span><br>
        Knee Angle: <span :class="{'text-success': checkAngle('knee')}">{{ kneeAngle }}°</span><br>
      </div>
    </div>
    <loader v-if="loading"></loader>
    <div
      class="z-index-top w-100 h-100 position-absolute d-flex flex-column justify-content-center align-items-center text-white countdown-background"
      v-if="showCounter"
    >
      <label
        class="position-absolute z-index-top text-center text-white font-weight-bold left-0 top-0 mt-2 ml-2 font-26"
        v-if="showCounter"
        >Powered by<br />
        EliteFit.AI</label
      >
      <!-- <img
        src="../assets/images/active-health.png"
        alt="active-health"
        class="position-absolute top-0 right-0 mt-2"
        width="170px"
      /> -->
      <label class="font-60 mb-4">Countdown starts</label>
      <label class="font-16">Get Ready in ...</label>
      <label class="font-80">{{ countdown }}</label>
    </div>
    <div class="w-70 h-100 bg-black position-relative">
       <video
        style="position: absolute; top: 0; left: 0;"
        class="w-100 h-100 input-video"
        ref="defaultUserVideo"
        v-if="!isCameraInit"
        playsInline
        autoplay
        ></video>
      <video
        class="w-100 h-100 input-video"
        ref="userVideo"
        playsInline
        v-show="isCameraInit"
        autoplay
      ></video>
      <canvas
        ref="canvas"
        v-show="isCameraInit"
        class="rounded mw-100 mh-100 position-absolute left-0 right-0 bottom-0  top-0 m-auto"
      ></canvas>   
    </div>
    <div
      class="w-30 h-100 d-flex flex-column justify-content-start align-items-center text-white"
    >
      <div
        class="w-100 h-50 bg-yellow d-flex justify-content-center align-items-center"
      >
        <radial-progress-bar
          :diameter="300"
          :completed-steps="workoutTime"
          :total-steps="totalTime"
          :isClockwise="false"
          :innerStrokeColor="'#c7d0d8'"
          :startColor="'#ffffff'"
          :stopColor="'#ffffff'"
          :innerStrokeWidth="5"
        >
          <label class="font-40 font-weight-bold"
            >00:{{ workoutTime.toString().padStart(2, "0") }}</label
          >
        </radial-progress-bar>
      </div>
      <div
        class="d-flex flex-column justify-content-center align-items-start w-100"
      >
        <label
          class="font-32 text-black my-5 d-flex justify-content-between w-100 px-5"
        >
          Valid Rep Count:
          <span class="ms-5 text-green">{{ validRepCount | round }}</span>
        </label>
        <label
          class="font-32 text-black mb-5 d-flex justify-content-between w-100 px-5"
        >
          Invalid Rep Count:
          <span class="ms-5 text-danger">{{ invalidRepsCount | round }}</span>
        </label>
        <div
          class="px-3 py-2 bg-brown cursor-pointer align-self-center"
          @click="cancelWorkout()"
        >
          Cancel
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadialProgressBar from "vue-radial-progress";
import eliteService from "@/module_user/api/elite-service";
import { EliteRepSportSG  as EliteRep} from "@/elite-lib-yt";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapMutations } = createNamespacedHelpers("b2bClient");
export default {
  name: "WorkoutView",
  components: {
    RadialProgressBar,
  },
  data() {
    return {
      totalTime: 60,
      countdown: 10,
      showCounter: false,
      eliteRep: null,
      visible: false,
      total: 0,
      validRepCount: 0,
      invalidRepsCount: 0,
      workoutTime: 60,
      workoutInterval: null,
      kneeAngle: 0,
      hipAngle: 0,
      showDebug: true,
      baseline: null,
      totalRepDeviation: 35,
      isUserHeightShort: String(this.$route.query?.height).toLowerCase() === 'no',
      //SIT - STAND - SIT
      sitToStandBaseLine: {
        name: 'sitToStandBaseLine',
        // Sit
        form: [
          { p1: 11, p2: 23, p3: 25, a: 90, nd: 20, pd: 20 }, // Hip
          { p1: 23, p2: 25, p3: 27, a: 90, nd: 15, pd: 15 }, // Knee
        ],
        motion: [
          // Stand
          [
            { p1: 11, p2: 23, p3: 25, a: 165, nd: 15, pd: 15 }, // Hip
            { p1: 23, p2: 25, p3: 27, a: 165, nd: 15, pd: 15 }, // Knee
          ],
          // Sit
          [
            { p1: 11, p2: 23, p3: 25, a: 90, nd: 20, pd: 20 }, // Hip
            { p1: 23, p2: 25, p3: 27, a: 90, nd: 15, pd: 15 }, // Knee
          ],
        ],
      },
      //STAND - SIT - STAND
      sitToStandBaseLine2: {
        name: 'sitToStandBaseLine2',
        // Stand
        form: [
          { p1: 11, p2: 23, p3: 25, a: 165, nd: 15, pd: 15 }, // Hip
          { p1: 23, p2: 25, p3: 27, a: 165, nd: 15, pd: 15 }, // Knee
        ],
        motion: [
          // Sit
          [
            { p1: 11, p2: 23, p3: 25, a: 90, nd: 20, pd: 20 }, // Hip
            { p1: 23, p2: 25, p3: 27, a: 90, nd: 15, pd: 15 }, // Knee
          ],
          // Stand
          [
            { p1: 11, p2: 23, p3: 25, a: 165, nd: 15, pd: 15 }, // Hip
            { p1: 23, p2: 25, p3: 27, a: 165, nd: 15, pd: 15 }, // Knee
          ]
        ],
      },
      //Baseline
      sitToStandBaseLine3: {
        name: 'sitToStandBaseLine3',
        // Sit
        form: [
          { p1: 11, p2: 23, p3: 25, a: 67, nd: 23, pd: 23 }, // Hip 44 to 90
          { p1: 23, p2: 25, p3: 27, a: 90, nd: 15, pd: 15 }, // Knee 75 to 105
        ],
        motion: [
          // Stand
          [
            { p1: 11, p2: 23, p3: 25, a: 165, nd: 15, pd: 15 }, // Hip
            { p1: 23, p2: 25, p3: 27, a: 165, nd: 15, pd: 15 }, // Knee
          ],
          // Sit
          [
            { p1: 11, p2: 23, p3: 25, a: 67, nd: 23, pd: 23 }, // Hip 44 to 90
            { p1: 23, p2: 25, p3: 27, a: 90, nd: 15, pd: 15 }, // Knee 75 to 105
          ],
        ],
      },
      //Baseline for Users height 145cm and above
      defaultBaseline: {
        name: 'Users height 145cm and above',
        // Sit
        form: [
          { p1: 11, p2: 23, p3: 25, a: 77, nd: 33, pd: 33 }, // Hip 45 to 110
          { p1: 23, p2: 25, p3: 27, a: 90, nd: 15, pd: 15 }, // Knee 75 to 105
        ],
        motion: [
          // Stand
          [
            { p1: 11, p2: 23, p3: 25, a: 165, nd: 15, pd: 15 }, // Hip 150 to 180
            { p1: 23, p2: 25, p3: 27, a: 165, nd: 15, pd: 15 }, // Knee 150 to 180
          ],
          // Sit
          [
            { p1: 11, p2: 23, p3: 25, a: 77, nd: 33, pd: 33 }, // Hip 45 to 110
            { p1: 23, p2: 25, p3: 27, a: 90, nd: 15, pd: 15 }, // Knee 75 to 105
          ],
        ],
      },
      //Baseline for Users height below 145cm
      shortHeightUserBaseline: {
        name: 'Users height below 145cm',
        // Sit
        form: [
          { p1: 11, p2: 23, p3: 25, a: 96, nd: 51, pd: 54 }, // Hip 45 to 150
          { p1: 23, p2: 25, p3: 27, a: 113, nd: 38, pd: 37 }, // Knee 75 to 150
        ],
        motion: [
          // Stand
          [
            { p1: 11, p2: 23, p3: 25, a: 165, nd: 15, pd: 15 }, // Hip 150 to 180
            { p1: 23, p2: 25, p3: 27, a: 165, nd: 15, pd: 15 }, // Knee 150 to 180
          ],
          // Sit
          [
            { p1: 11, p2: 23, p3: 25, a: 96, nd: 51, pd: 54 }, // Hip 45 to 150
            { p1: 23, p2: 25, p3: 27, a: 113, nd: 38, pd: 37 }, // Knee 75 to 150
          ],
        ],
      },
      activeWebCam : null,
      isCameraInit : false
    };
  },
  filters: {
    round(value) {
      return Math.floor(value);
    },
  },
  methods: {
    ...mapMutations(["setLoading"]),
    userDetails() {
      const params = this.$route.query?.height;
      this.$router.push(`/ActiveHealth/user-details?height=${params}`);
    },
    cancelWorkout() {
      if (confirm("Are you sure you want to end your workout now?")) {
        this.$router.push({ name: "intro-page" });
      }
    },
    onResult(count, total) {
      this.total = total;
      this.validRepCount = (count < 0)? 0 : Math.floor(count);
      const invalidReps = Math.floor(total - count);
      this.invalidRepsCount = (invalidReps < 0)? 0 : invalidReps;
    },
    onVisibilityChange(visible) {
      this.visible = visible;
    },

    startCounter() {
      this.showCounter = true;
      const timeout = setInterval(() => {
        if (this.countdown >= 1) {
          this.countdown--;
        } else {
          this.showCounter = false;
          this.startWorkout();
          clearInterval(timeout);
        }
      }, 1000);
    },
    startWorkout() {
      this.eliteRep.form = 0;
      this.eliteRep.start = true;
      this.total = 0;
      this.validRepCount = 0;
      this.invalidRepsCount = 0;
      this.workoutInterval = setInterval(() => {
        if (this.workoutTime <= 0) {
          this.stopWorkout();
        } else {
          this.workoutTime--;
        }
      }, 1000);
    },
    stopWorkout() {
      localStorage.setItem(
        "workoutData",
        JSON.stringify({
          repCount: this.validRepCount,
          invalidRep: this.invalidRepsCount,
        })
      );
      clearInterval(this.workoutInterval);
      this.userDetails();
    },
    /**
     * For debugging - Check if the angles are in the range of expected angle
     * */
    checkAngle(key) {
      if (key === 'hip') {
        if (this.isUserHeightShort) {
          return (this.hipAngle > 150 && this.hipAngle < 180) || (this.hipAngle > 45 && this.hipAngle < 150);
        }
        return (this.hipAngle > 150 && this.hipAngle < 180) || (this.hipAngle > 45 && this.hipAngle < 110);
      }
      if (key === 'knee') {
        if (this.isUserHeightShort) {
          return (this.kneeAngle > 150 && this.kneeAngle < 180) || (this.kneeAngle > 75 && this.kneeAngle < 150);
        }
        return (this.kneeAngle > 150 && this.kneeAngle < 180) || (this.kneeAngle > 75 && this.kneeAngle < 105);
      }
    },
    /**
     * For debugging - get angles of hip & knee
    * */
    poseLandmarksCallback(landmarks) {
      this.hipAngle = Math.round(this.eliteRep.getAngle(landmarks, 11, 23, 25));
      this.kneeAngle = Math.round(this.eliteRep.getAngle(landmarks, 23, 25, 27));
    },
    async stopWebCam(stream) {
      let tracks = stream.getTracks();
      for(const track of tracks){
        await track.stop()
      }
    },
    async loadWebCam(deviceId) {
      const stream = this.$refs.userVideo.srcObject;
      if (stream) await this.stopWebCam(stream);
      let constraints = {audio: false, video: {deviceId: {exact: deviceId}}};
      try {
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        this.$refs.userVideo.srcObject = stream;
        if(this.$refs.defaultUserVideo){
          this.$refs.defaultUserVideo.srcObject = stream;
        }
      } catch (error) {
        return error;
      }
    },

    onWebCamChange() {
      const webCamEl = this.$refs.userVideo;
      const {deviceId} = webCamEl.srcObject?.getVideoTracks()[0].getSettings();
      if (deviceId && deviceId != this.activeWebCam) this.activeWebCam = deviceId;
    },
  },
  async mounted() {

    const mode = this.$route.params?.mode;
    if (mode) {
      this.showDebug = (mode === 'debug');
    }

    this.baseline = this.defaultBaseline;

    if (this.isUserHeightShort) {
      this.baseline = this.shortHeightUserBaseline;
    }

    const baselineOption = this.$route.query?.bl;
    if (baselineOption) {
      switch (baselineOption) {
        case '1':
          this.baseline = this.sitToStandBaseLine;
          break;
        case '2':
          this.baseline = this.sitToStandBaseLine2;
          break;
        case '3':
          this.baseline = this.sitToStandBaseLine3;
          break;
        case '4':
          this.baseline = this.defaultBaseline;
          break;
      }
    }

    const totalRepDeviation = this.$route.query?.d;
    if (totalRepDeviation) {
      this.totalRepDeviation = +totalRepDeviation;
    }

    this.setLoading(true);
    this.eliteRep = new EliteRep(eliteService, {
      baseLine: this.baseline,
      onResult: this.onResult,
      onVisibilityChange: this.onVisibilityChange,
      poseLandmarksCallback: this.poseLandmarksCallback,
      totalRepDeviation: this.totalRepDeviation
    });
    this.eliteRep.start = false;
    // Initialize Camera & BlazePose
    const cameraId = localStorage.getItem('default_camera')
    this.$refs.userVideo.addEventListener('loadedmetadata', this.onWebCamChange);
    if(cameraId){
      await this.loadWebCam(cameraId)
    }
    await this.eliteRep.initCamera(
      this.$refs.userVideo,
      this.$refs.canvas,
      null, // No instructor video element required
      0, // Video ID is not required
      true // This will only initialize BlazePose and no session will get created and no poses will get stored
    );
    if(cameraId){
      await this.loadWebCam(cameraId)
    }
    this.isCameraInit = true
    this.setLoading(false);
    this.startCounter();
  },
  computed: {
    ...mapState(["loading"]),
  },
  destroyed() {
    clearInterval(this.workoutInterval);
    this.eliteRep.dispose();
  },
};
</script>
<style scoped>
.input-video {
  max-width: 100%;
  transform: rotateY(180deg);
  -webkit-transform: rotateY(180deg); /* Safari and Chrome */
  -moz-transform: rotateY(180deg); /* Firefox */
}
.debug-window {
  position: absolute;
  z-index: 99;
  bottom: 10px;
  left: 10px;
}
.countdown-background {
  background-color: rgba(0, 0, 0, 0.10);
}
</style>
